<template>
  <div class="to-user text-dark">

    <h1 class="to-user__headline">{{ user.name }}, {{ schoolYear }}<span class="to-d-pill" v-if="version.vTitle">{{
        version.vTitle
      }}</span></h1>
    <!-- NORM -->
    <table class="d-table marg-1-bottom d-table__overview" v-if="userNorm.length > 0">
      <thead>
      <tr>
        <th><h4>{{ $t('vue2.task_versions.annual_norm') }}</h4></th>
        <th class="is-number"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, idx) in userNormFormatted" v-if="idx < userNormFormatted.length - 1" :key="item.title">
        <td>{{ item.title }}</td>
        <td class="is-number">{{ item.value }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr v-for="(item, idx) in userNormFormatted" v-if="idx === userNormFormatted.length - 1" :key="item.title">
        <td>{{ item.title }}</td>
        <td class="is-number">{{ item.value }}</td>
      </tr>
      </tfoot>
    </table>
    <!-- FORDELING -->
    <table class="d-table marg-1-bottom d-table__overview" v-if="Object.keys(userPoolsFormatted).length > 0">
      <thead>
      <tr>
        <th><h4>{{ i18n['pools'] }}</h4></th>
        <th class="is-number">{{ $t('vue2.assign_users_hours.assigned') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(pool, prop) in userPoolsFormatted">
        <td>{{ prop }}</td>
        <td class="is-number">
          {{ pool }}
        </td>
      </tr>
      <tr v-if="rest">
        <td>Rest</td>
        <td class="is-number">
          {{ rest }}
        </td>
      </tr>
      </tbody>
    </table>
    <UserTasksOverviewOwnPools
      v-if="schoolSettingShownOwnPools && schoolSettingShownOwnPools.length > 0"
      :schoolSettingShownOwnPools="schoolSettingShownOwnPools"
      :isShowScheduled="false"
      :userTasks="tasksByMasterType">
    </UserTasksOverviewOwnPools>
    <!-- TASKS -->
    <TaskOverviewUserTasks
      :user="user"
      :tasks="tasks"
      :tasksByMasterType="tasksByMasterType"
      :schoolThresholdToHideTaskHours="schoolThresholdToHideTaskHours"
      :isHideTaskHoursUnderThreshold="isHideTaskHoursUnderThreshold">
    </TaskOverviewUserTasks>
    <!-- Agreements -->
    <div class="to-agreements" v-if="userAgreements && userAgreements.length > 0">
      <div class="to-agreements__header">
        <h4>{{ i18n['notes'] }}</h4>
      </div>
      <div class="to-agreements__body" v-html="userAgreements"></div>
    </div>
  </div>
</template>

<script>
import UserTasksOverviewOwnPools from '../UserTasksOverviewOwnPools.vue'

const I18N = {
  da: {
    assigned_total_hours: 'Arbejdstid',
    assigned_teaching_hours: 'Undervisning',
    assigned_preparation_hours: 'Forberedelse',
    assigned_additional_task_hours: 'Øvrige opgaver',
    assigned_pool_hours: 'Lokalpulje',
    assigned_club_hours: 'SFO timer',
    substitute_pool_hours: 'Vikartimer',
    notes: 'Noter/særlige aftaler',
    pools: 'Fordeling'
  },
  nb: {
    assigned_total_hours: 'Arbeidstid',
    assigned_teaching_hours: 'Undervisning',
    assigned_preparation_hours: 'Forberedelse',
    assigned_additional_task_hours: 'Oppgaver',
    substitute_pool_hours: 'Vikartimer',
    assigned_pool_hours: 'Planegginsdager',
    assigned_club_hours: 'SFO timer',
    notes: 'Noter/særlige aftaler',
    pools: 'Puljer'
  },
  en: {
    assigned_club_hours: 'Club Hours',
    assigned_pool_hours: 'Local pool',
    assigned_total_hours: 'Work time',
    substitute_pool_hours: 'Substitute hours',
    assigned_teaching_hours: 'Teaching',
    assigned_preparation_hours: 'Preparation',
    assigned_additional_task_hours: 'Additional tasks',
    notes: 'Notes',
    pools: 'Pools'
  }
}
import TaskOverviewUserTasks from './TaskOverviewUserTasks'

export default {
  components: {UserTasksOverviewOwnPools, TaskOverviewUserTasks},
  props: {
    user: {},
    version: {
      default: () => null
    },
    isHideTaskHoursUnderThreshold: {
      default: false
    }
  },
  data () {
    return {
      isShowScheduled: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    schoolCustomData () {
      return this.version && this.version.overview && this.version.overview.school_custom_data
    },
    isPoolsDeactivated () {
      return this.schoolCustomData ? this.schoolCustomData.deactivatePools : false
    },
    schoolThresholdToHideTaskHours () {
      return this.schoolCustomData ? this.schoolCustomData.thresholdToHideTaskHours : null
    },
    schoolSettingShownOwnPools () {
      return this.schoolCustomData ? this.schoolCustomData.shownOwnPools : []
    },
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    schoolSettingPrepFactor () {
      return this.schoolSettings && this.schoolSettings['prepFactor'] ? this.schoolSettings['prepFactor'] : null // this.schoolCustomData ? this.schoolCustomData.prepFactor : null
    },
    schoolYears () {
      return this.$store.state.schoolYears
    },
    schoolYear () {
      if (!this.version || !this.version.school_year_id) {
        return ''
      }
      const idx = this.schoolYears.findIndex(schoolYear => schoolYear.id === this.version.school_year_id)
      return idx > -1 ? this.schoolYears[idx]['name'] : ''
    },
    userAgreements () {
      return this.version.overview && this.version.overview.agreements ? this.version.overview.agreements : ''
    },
    userNorm () {
      return this.version.overview.norm
    },
    userNormFormatted () {
      if (Object.keys(this.userNorm).length < 1) {
        return []
      }
      const normsFiltered = this.userNorm.filter(item => item.title.indexOf('hidden_') < 0)
      return normsFiltered.map(item => ({
        ...item,
        value: item.value
      }))
    },
    userPools () {
      return this.version.overview.pools
    },
    taskPools () {
      const result = {}

      // Hjælpefunktion til at formatere timer
      const formatHours = value => (value || value === 0 ? value.toFixed(2) : '0.00')

      // Først arbejdstid
      const totalWorkHours = this.userPools['assigned_total_hours']
      const translatedKey = this.i18n['assigned_total_hours'] || 'assigned_total_hours'
      const translatedPrep = this.i18n['assigned_preparation_hours']
      result[translatedKey] = formatHours(totalWorkHours)

      // Så alle brikker og puljer
      const taskTypes = this.schoolSettingPrepFactor ? this.tasksByOriginalType.filter(taskType => taskType.originalType !== 'preparation') : this.tasksByOriginalType
      taskTypes.forEach(taskType => {
        if (this.schoolSettingPrepFactor && taskType.originalType === 'teaching') {
          result[translatedPrep] = formatHours(taskType.totalHours * this.schoolSettingPrepFactor)
        }
        result[taskType.title] = formatHours(taskType.totalHours)
      })
      return result
    },
    userPoolsFormatted () {
      if (this.isPoolsDeactivated) {
        return this.taskPools
      }
      let result = {}
      // Create an array to hold the translated keys with their original order
      let translatedKeys = []
      for (let key in this.userPools) {
        if (this.userPools[key] !== null && this.userPools[key] !== 0) {
          let translatedKey = this.i18n[key] || key
          translatedKeys.push({key: translatedKey, originalKey: key})
        }
      }
      // Sort the translated keys based on the hierarchy in this.i18n
      translatedKeys.sort((a, b) => {
        return (
          Object.keys(this.i18n).indexOf(a.originalKey) -
          Object.keys(this.i18n).indexOf(b.originalKey)
        )
      })
      // Build the result object with sorted keys
      for (let item of translatedKeys) {
        result[item.key] = this.userPools[item.originalKey].toFixed(2)
      }
      return result
    },
    totalUserPools () {
      const poolsObj = this.isPoolsDeactivated ? this.taskPools : this.userPools
      let sum = 0
      for (const key in poolsObj) {
        if (key !== 'assigned_total_hours' && key !== this.i18n['assigned_total_hours']) {
          const value = poolsObj[key]
          const num = Number(value)
          if (!isNaN(num)) {
            sum += num
          }
        }
      }
      return sum
    },
    rest () {
      if (this.userPools.assigned_total_hours && this.userPools.assigned_total_hours > 0) {
        const remainingHours = this.userPools.assigned_total_hours - this.totalUserPools
        return remainingHours.toFixed(2)
      }
    },
    tasks () {
      return this.version.overview.tasks
    },
    tasksFiltered () {
      return this.tasks.filter(item => item.master_type !== 'unknown')
    },
    tasksByMasterType () {
      let pools = {}

      // Helper til at sikre tal og fallback til 0
      function getValidHours (val) {
        let num = parseFloat(val)
        return isNaN(num) ? 0 : num
      }

      this.tasksFiltered.forEach(task => {
        let hours = getValidHours(task.hours)

        // Skip hvis task ikke er actual og hours == 0, og der findes duplikater
        if (!task.actual && hours === 0) {
          let sameIdTasks = this.tasksFiltered.filter(t => t.id === task.id)
          if (sameIdTasks.length > 1) {
            return
          }
        }

        let activeType = task.task_category_name ? task.task_category_name : task.master_type

        if (task.substitute) {
          activeType = 'substitute_hours'
        }

        let title = this.getMasterTypeTitle(activeType)

        if (!pools[title]) {
          pools[title] = {
            originalType: activeType,
            tasks: [],
            totalHours: 0.0
          }
        }

        pools[title].tasks.push(task)
        pools[title].totalHours += hours
      })

      for (let pool in pools) {
        pools[pool].tasks.sort((a, b) => {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
      }

      let poolsArray = Object.entries(pools).map(([title, { originalType, tasks, totalHours }]) => ({
        title: title === 'substitute_hours' ? this.getMasterTypeTitle('substitute_hours') : title,
        originalType,
        tasks,
        totalHours
      }))

      poolsArray.sort((a, b) => {
        let aOrder = this.sortOrder[a.originalType] !== undefined ? this.sortOrder[a.originalType] : 999
        let bOrder = this.sortOrder[b.originalType] !== undefined ? this.sortOrder[b.originalType] : 999
        return aOrder - bOrder
      })

      return poolsArray.filter(pool => pool.originalType !== 'absence')
    },

    tasksByOriginalType () {
      let pools = {}

      function getValidHours (val) {
        let num = parseFloat(val)
        return isNaN(num) ? 0 : num
      }

      this.tasksFiltered.forEach(task => {
        let hours = getValidHours(task.hours)
        let masterTypeTitle = this.getMasterTypeTitle(task.master_type)

        if (!pools[masterTypeTitle]) {
          pools[masterTypeTitle] = {
            originalType: task.master_type,
            tasks: [],
            totalHours: 0.0
          }
        }

        pools[masterTypeTitle].totalHours += hours

        if (task.substitute && !pools['substitute_hours']) {
          pools['substitute_hours'] = {
            originalType: 'substitute_hours',
            tasks: [task],
            totalHours: hours
          }
        } else if (task.substitute) {
          pools['substitute_hours'].tasks.push(task)
          pools['substitute_hours'].totalHours += hours
        } else {
          pools[masterTypeTitle].tasks.push(task)
        }
      })

      for (let pool in pools) {
        pools[pool].tasks.sort((a, b) => {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
      }

      let poolsArray = Object.entries(pools).map(([title, {originalType, tasks, totalHours}]) => ({
        title: title === 'substitute_hours' ? this.getMasterTypeTitle('substitute_hours') : title,
        originalType,
        tasks,
        totalHours
      }))

      poolsArray.sort((a, b) => {
        let aOrder = this.sortOrder[a.originalType] !== undefined ? this.sortOrder[a.originalType] : 999
        let bOrder = this.sortOrder[b.originalType] !== undefined ? this.sortOrder[b.originalType] : 999
        return aOrder - bOrder
      })

      return poolsArray.filter(pool => pool.originalType !== 'absence')
    },
    sortOrder () {
      return {
        teaching: 0,
        substitute_hours: 1,
        other: 2,
        preparation: 3,
        club: 4,
        absence: 8,
        unknown: 8,
        with_kids: 0,
        without_kids: 2
      }
    }
  },
  methods: {
    getMasterTypeTitle (title) {
      switch (title) {
        case 'teaching':
          return this.$t('vue2.task_overview.teaching')
        case 'other':
          return this.$t('vue2.task_overview.tasks')
        case 'preparation':
          return this.$t('vue2.task_overview.preparation')
        case 'absence':
          return this.$t('vue2.task_overview.absence')
        case 'club':
          return this.$t('vue2.task_overview.club')
        case 'substitute_hours':
          return this.$t('vue2.task_overview.substitute_hours')
        case 'pool':
          return this.$t('vue2.task_overview.pool')
        case 'with_kids':
          return 'Tid med børn'
        case 'without_kids':
          return 'Tid uden børn'
        default:
          return title
      }
    }
  }
}
</script>


<style scoped>
.to-user {
  background-color: #fff;
  padding: 1rem;
}

@media print {
  .to-user {
    page-break-after: always;
  }
}

.d-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.d-table tr td:first-child {
  padding-left: 2rem;
}

.is-number {
  text-align: right;
}

.to-agreements {
  border: 1px solid #e2e8f0;
}

.to-agreements__header {
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
  padding: 5px;
  border-bottom: 1px solid #e2e8f0;
}

.to-agreements__body {
  padding: 4px 4px 4px 2rem;
}

.to-d-pill {
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  background-color: #fefce8;
  color: #854d0f;
  padding: 4px 8px;
  font-weight: bold;
  border: 1px solid #f4e6c0;
  font-size: 11px;
  margin-left: 1rem;
}

.to-user__headline {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// TaskOverviewUser.vue?710e269c